import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UserPanelViewLayer from "../../components/UserPanelViewLayer";

const ViewProfilePage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="View user" />
      <UserPanelViewLayer />
    </MasterLayout>
  );
};

export default ViewProfilePage;
